// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { recordAnalyticsForSellerTestimonialsPageView } from '../../../redux/modules/analytics';
import { sleep } from '../../../utils/sleep';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([sleep(1500)]).then(() => {
        return dispatch(recordAnalyticsForSellerTestimonialsPageView());
    });
};
